"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var input_list_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/input/input_list_store"));
var abstract_input_store_1 = require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store");
var item_input_card_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/item_input_card"));
var input_store_factory_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory"));
var form_builder_validator_1 = __importDefault(require("@hikakaku/shared/validator/forms/form_builder_validator"));
var GROUP_PREFIX = "GROUP";
var WATCH_URL = /^\/(estimate_form\/watch|lp\/watch(\/(rolex\/c3|seiko|omega)?)?)$/;
var ItemInputCardStore = /** @class */ (function () {
    function ItemInputCardStore(props) {
        var _this = this;
        this.component = item_input_card_1.default;
        this.index = 0;
        this.groupId = "";
        this.isCategorySelected = function (id) {
            var _a;
            return String((_a = _this.categorySelectorInputStore) === null || _a === void 0 ? void 0 : _a.value) === id;
        };
        this.hasValueInInputStoreByRawName = function (rawName) {
            var _a;
            return Boolean((_a = _this.inputListStore.findInputStoreByRawName(rawName)) === null || _a === void 0 ? void 0 : _a.value);
        };
        this.handleClickDeleteButton = function () {
            _this.onClickDeleteButton(_this.index);
        };
        this.validate = function () {
            return _this.inputListStore.inputStores.length > 0 && form_builder_validator_1.default.validate(_this.inputListStore) || false;
        };
        this.handleChangeCategory = function (categoryId) {
            if (categoryId && categoryId.startsWith(GROUP_PREFIX)) {
                _this.groupId = categoryId;
            }
            else {
                _this.fetchCategoryItemInputList(categoryId).then(function (inputProps) {
                    var hiddenCategoryInput = {
                        name: "estimate_form[items][".concat(_this.cardNumber, "][category_id]"),
                        rawName: 'category_id',
                        type: input_store_factory_1.InputType.HIDDEN,
                        defaultValue: categoryId,
                        label: '',
                        necessary: false
                    };
                    var mergedInputProps = __spreadArray(__spreadArray([], inputProps, true), [
                        hiddenCategoryInput
                    ], false);
                    _this.inputListStore = new input_list_store_1.default({ inputProps: mergedInputProps });
                });
            }
        };
        this.handleWatchChange = function (data) {
            var importCategoryId = data[0];
            var categoryId = data[1];
            _this.fetchCategoryItemInputList("".concat(importCategoryId, "/").concat(categoryId)).then(function (inputProps) {
                var hiddenCategoryInput = {
                    name: "estimate_form[items][".concat(_this.cardNumber, "][category_id]"),
                    rawName: 'category_id',
                    type: input_store_factory_1.InputType.HIDDEN,
                    defaultValue: categoryId,
                    label: '',
                    necessary: false
                };
                var mergedInputProps = __spreadArray(__spreadArray([], inputProps, true), [
                    hiddenCategoryInput
                ], false);
                _this.inputListStore = new input_list_store_1.default({ inputProps: mergedInputProps });
            });
        };
        this.createCategorySelectorInput = function (categorySelector, defaultValue) {
            var label = '商品カテゴリ';
            var description = '商品カテゴリを選択してください';
            var type = input_store_factory_1.InputType.NESTED_SELECT;
            var onChange = _this.handleChangeCategory;
            var path = typeof window !== 'undefined' ? window.location.pathname.replace(/\/$/, '') : '';
            if (path.match(WATCH_URL)) {
                label = 'ブランド';
                description = 'ブランドを入力してください';
                type = input_store_factory_1.InputType.WATCH_SELECT;
                onChange = _this.handleWatchChange;
            }
            return input_store_factory_1.default.createInputStore({
                type: type,
                name: 'import_category_id',
                necessary: true,
                label: label,
                description: description,
                options: categorySelector,
                onChange: onChange,
                clearButtonHelpText: 'カテゴリをリセット',
                defaultValue: defaultValue
            });
        };
        this.cardNumber = props.cardNumber;
        this.cardRef = react_1.default.createRef();
        this.fetchCategoryItemInputList = props.fetchCategoryItemInputList;
        this.onClickDeleteButton = props.onClickDeleteButton;
        this.inputListStore = new input_list_store_1.default({ inputProps: props.inputProps });
        if (props.categorySelectorOptions) {
            var defaultValue = props.defaultImportCategory
                ? props.defaultImportCategory
                : props.defaultImportCategoryGroup
                    ? "".concat(GROUP_PREFIX, "#").concat(props.defaultImportCategoryGroup)
                    : undefined;
            this.categorySelectorInputStore = this.createCategorySelectorInput(props.categorySelectorOptions, defaultValue);
        }
    }
    Object.defineProperty(ItemInputCardStore.prototype, "value", {
        get: function () {
            return this.inputListStore.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemInputCardStore.prototype, "hasImportCategoryId", {
        get: function () {
            var _a;
            return Boolean((_a = this.categorySelectorInputStore) === null || _a === void 0 ? void 0 : _a.value);
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ItemInputCardStore.prototype, "index", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof abstract_input_store_1.IInputStore !== "undefined" && abstract_input_store_1.IInputStore) === "function" ? _a : Object)
    ], ItemInputCardStore.prototype, "categorySelectorInputStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_b = typeof input_list_store_1.IInputListStore !== "undefined" && input_list_store_1.IInputListStore) === "function" ? _b : Object)
    ], ItemInputCardStore.prototype, "inputListStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ItemInputCardStore.prototype, "groupId", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof input_list_store_1.InputListValue !== "undefined" && input_list_store_1.InputListValue) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], ItemInputCardStore.prototype, "value", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ItemInputCardStore.prototype, "hasImportCategoryId", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardStore.prototype, "isCategorySelected", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardStore.prototype, "hasValueInInputStoreByRawName", void 0);
    return ItemInputCardStore;
}());
exports.default = ItemInputCardStore;
